import React, { useEffect, useState } from 'react';
import { BarChart, Bar, CartesianGrid, ResponsiveContainer, Tooltip } from 'recharts';
import { CheckCircle } from 'lucide-react';
import { useLazyGetSpendingMetricsQuery } from '../../../../services/Api';

export default function SpendingMetrics() {
    const [trigger, { data, isLoading, error }] = useLazyGetSpendingMetricsQuery();
    const [chartData, setChartData] = useState([
        { name: 'Jan', value: 0, remaining: 100 },
        { name: 'Feb', value: 0, remaining: 100 },
        { name: 'Mar', value: 0, remaining: 100 },
        { name: 'Apr', value: 0, remaining: 100 },
        { name: 'May', value: 0, remaining: 100 },
        { name: 'Jun', value: 0, remaining: 100 },
        { name: 'Jul', value: 0, remaining: 100 },
        { name: 'Aug', value: 0, remaining: 100 },
        { name: 'Sep', value: 0, remaining: 100 },
        { name: 'Oct', value: 0, remaining: 100 },
        { name: 'Nov', value: 0, remaining: 100 },
        { name: 'Dec', value: 0, remaining: 100 }
    ]);

    useEffect(() => {
        trigger();
    }, []);

    useEffect(() => {
        if (data?.success) {
            const maxValue = Math.max(...data.data.map(item => item.value));

            const processedData = chartData.map(item => {
                const Item = data.data.find(d => d.name === item.name);
                const value = Item?.value || 0;
                const percentage = maxValue > 0 ? (value / maxValue) * 300 : 0;
                return {
                    name: item.name,
                    value: value,
                    displayValue: percentage,
                    remaining: 300 - percentage,
                    actualValue: value
                };
            });
            setChartData(processedData);
        }
    }, [data]);

    const formatCurrency = (value) => {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        }).format(value);
    };

    return (
      <div className="bg-lightgreen p-3 sm:p-4 md:p-6 rounded-[1.75rem] w-full max-w-[100vw] overflow-hidden h-full">
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-4 sm:mb-6">
          <div className="w-full sm:w-auto">
            <p className="text-lightgray font-quicksand text-xs sm:text-sm font-medium mb-1">
              Spent this month
            </p>
            <h2 className="font-roboto-mono text-1xl sm:text-xl md:text-xl font-medium">
              {formatCurrency(
                data?.data?.reduce((acc, item) => acc + item.value, 0) || 0
              )}
            </h2>
          </div>
          <div className="flex items-center gap-2 mt-2 sm:mt-0">
            <CheckCircle className="w-4 h-4 sm:w-5 sm:h-5 text-[#4A6741]" />
            <span className="text-[#4A6741] font-quicksand text-xs sm:text-sm md:text-base font-bold">
              On track
            </span>
          </div>
        </div>

        <div className="h-[140px] sm:h-[180px] md:h-[250px] lg:h-[280px] w-full">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart
              data={chartData}
              barCategoryGap="30%"
              barGap={4}
              barSize={16}
              margin={{ top: 20, right: 8, bottom: 0, left: 8 }}
              
            >
              <CartesianGrid vertical={false} horizontal={false} />
              <Tooltip
                cursor={false}
                formatter={(value, name, props) => {
                  const actualValue = props.payload.actualValue;
                  return [
                    formatCurrency(actualValue),
                    name === "displayValue" ? "Spent" : "Remaining",
                  ];
                }}
                contentStyle={{
                  backgroundColor: "#fff",
                  border: "1px solid #e0e0e0",
                  borderRadius: "8px",
                  padding: "8px 12px",
                }}
              />
              <Bar
                dataKey="remaining"
                stackId="a"
                fill="#ECEBDE"
                radius={[12, 12, 12, 12]}
              />
              <Bar
                dataKey="displayValue"
                stackId="a"
                fill="#D9DCB0"
                radius={[12, 12, 12, 12]}
              />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    );
}
